'use strict';

/*
    Example:

    <take-photo-component
        user-type="Staff"
        user-id="staff.id"
        original-image="originalImageSrc()"
        able-to-change="hasPermission('Staff handling')"
        able-to-remove="hasPermission('Staff handling')"
        fb-button="customer.fbid && !isFacebookImage(customer)">
    </take-photo-component>

*/

var util = angular.module('gymsystem.util');

util.factory('takePhoto', ['$rootScope', '$q', function($rootScope, $q) {
    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    window.URL.createObjectURL = window.URL.createObjectURL || window.URL.webkitCreateObjectURL || window.URL.mozCreateObjectURL || window.URL.msCreateObjectURL;

    var ableToUse = (navigator.getUserMedia && window.URL) || $rootScope.isExpoApp();

    // check if device has video camera
    if(ableToUse && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
        navigator.mediaDevices.enumerateDevices().then(function(devices) {
            ableToUse = false;
            devices.forEach(function(device) {
                if(device.kind === 'videoinput') {
                    ableToUse = true;
                }
            });
        });
    } else {
        if(ableToUse && window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
            window.MediaStreamTrack.getSources(function(devs) {
                ableToUse = false;
                for(var i=0; i<devs.length; i++) {
                    if(devs[i].kind==='video') {
                        ableToUse = true;
                        return;
                    }
                }
            });
        }
    }

    var self = {};
    self.ableToUse = function() {
        return ableToUse;
    };
    self.takePhoto = function(option) {
        option = option || {};
        var deferred = $q.defer();
        if(!self.ableToUse) {
            deferred.reject();
            return deferred.promise;
        }

        if($rootScope.isExpoApp()) {
            var method = option.captureMode ? 'camera' : 'cameraroll';
            $rootScope.expoAsyncCall('selectImage', { method: method }, deferred.resolve, deferred.reject);
            return deferred.promise;
        }

        navigator.mediaDevices.getUserMedia({video: true}).then(function(stream) {
            var video;
            if(option.videoElement) {
                video = option.videoElement;
                video.autoplay = true;
                video.srcObject = stream;
            } else {
                video = document.createElement('video');
                video.autoplay = true;
                video.style.position = 'fixed';
                video.style.left = '-5000px';
                video.srcObject = stream;
                document.body.appendChild(video);
            }

            function capturePhoto() {
                var canvas = document.createElement('canvas');
                canvas.width = video.clientWidth;
                canvas.height = video.clientHeight;
                var context = canvas.getContext('2d');
                context.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
                var base64dataUrl = canvas.toDataURL('image/png');
                stream.getTracks()[0].stop();

                if(!option.videoElement) {
                    document.body.removeChild(video);
                }

                deferred.resolve(base64dataUrl);
            }

            if(option.captureMode) {
                deferred.promise.capture = capturePhoto;
            } else {
                video.onloadedmetadata = capturePhoto;
            }

        }).catch(function() {
            deferred.reject();
        });

        return deferred.promise;
    };
    return self;
}]);

util.directive('ngGetElement', ['$parse', function($parse) {
    return {
        link: function($scope, $element, $attrs) {
            setTimeout(function() {
                $parse($attrs.ngGetElement).assign($scope, $element[0]);
            }, 10);
        }
    };
}]);

util.directive('ngGetElement2', ['$parse', function($parse) {
    return {
        link: function($scope, $element, $attrs) {
            if($attrs.ngGetElement2) {
                var fn = $parse($attrs.ngGetElement2)($scope);
                if(fn) { fn($element[0]);}
            }
        }
    };
}]);


/*
    ng-event
    Description: listen any event
    Syntax: "list_of_event_names: js_expression"
    Example:
        ng-event="input,keyup,blur: cart.onChanged(row, $event, $element)"

*/
util.directive('ngEvent', ['$parse', function($parse) {
    return {
        link: function($scope, $element, $attrs) {
            var exp = $attrs.ngEvent;
            if(exp) {
                var element = $element[0];
                var i = exp.indexOf(':');
                var events = exp.slice(0, i).split(',');
                var callbackExp = exp.slice(i + 1);
                var fn = $parse(callbackExp);
                var fire = function(event) {
                    $scope.$apply(function() {
                        fn($scope, {$event: event, $element: element});
                    });
                };

                events.forEach(function(eventName) {
                    eventName = eventName.trim();
                    element.addEventListener(eventName, fire);
                    $scope.$on('$destroy', function() {
                        element.removeEventListener(eventName, fire);
                    });
                });
            }
        }
    };
}]);

util.directive('takePhotoComponent', ['$rootScope', '$parse', 'takePhoto', 'usSpinnerService', '$injector', 'confirm', '$modal', '$compile', 'server', 'fileManager',
    function($rootScope, $parse, takePhoto, usSpinnerService, $injector, confirm, $modal, $compile, server, fileManager) {
    return {
        scope: {},
        restrict: 'AE',
        templateUrl: 'views/takephoto.html',
        link: function($scope, $element, $attrs) {
            var empty = function(){};
            var $parent = $scope.$parent;

            $scope.data = {
                imageSrc: '',
                imageSelection: null,
                selectedFile: null,
                //videoElement: null,
                //fileInputElement: null,
                takingPhoto: false
            };

            // props
            var originalImageFn = $attrs.originalImage?$parse($attrs.originalImage):empty;
            var ableToChangeFn = $attrs.ableToChange?$parse($attrs.ableToChange):empty;
            var ableToRemoveFn = $attrs.ableToRemove?$parse($attrs.ableToRemove):empty;
            var ableToRemoveFn = $attrs.ableToRemove?$parse($attrs.ableToRemove):empty;
            var fbButtonFn = $attrs.fbButton?$parse($attrs.fbButton):empty;

            $scope.isQRCodeEntry = function() {
                if($attrs.userType === 'Member:Server') { return false; }
                else {
                    var user = $rootScope.getMember($parse($attrs.userId)($parent));
                    return user && (user.resourceType === 'qrcode_entry' || user.resourceType === 'door' && user.connect_qrcode_entry);
                }
            };
            $scope.isDoor = function() {
                if($attrs.userType === 'Member:Server') { return false; }
                else {
                    var user = $rootScope.getMember($parse($attrs.userId)($parent));
                    return user && user.resourceType === 'door';
                }
            };
            $scope.originalImage = function() {return originalImageFn($parent);};
            $scope.ableToChooseFile = function() {return !$scope.data.takingPhoto && ableToChangeFn($parent) && !$scope.isQRCodeEntry() && !$scope.isDoor();};
            $scope.ableToTakePhoto = function() {return !$scope.data.takingPhoto && takePhoto.ableToUse() && ableToChangeFn($parent) && !$scope.isQRCodeEntry() && !$scope.isDoor();};
            $scope.ableToRemove = function() { return !$scope.data.takingPhoto && !$scope.data.imageSrc && ableToRemoveFn($parent) && !$scope.isQRCodeEntry() && !$scope.isDoor(); };
            $scope.fbButton = function() {return !$scope.data.imageSrc && fbButtonFn($parent) && !$scope.isQRCodeEntry() && !$scope.isDoor();};
            $scope.isResourceSetting = function() { return $attrs.extraInfo === 'resourceSetting'; };
            $scope.openFileManager = function() {
                var user = $rootScope.getMember($parse($attrs.userId)($parent));
                var option = {chooseImage: true, imageOnly: true, originId: user.id, originType: 'user'};
                fileManager.chooseFile(option).then(function(result) {
                    $scope.data.imageSrc = fileManager.fileLinkByKey(result.key);
                    $scope.data.imageSelection = {x1: 0, y1: 0, x2: 250, y2: 250, width: 250, height: 250};
                    server.post('/api/resource/change', {id: user.id, imagekey: result.key}).then(function() {
                        $scope.data.imageSrc = null;
                        $scope.data.imageSelection = null;
                    });
                });
            };

            $scope.takePhoto = function() {
                var oldSelectedFile = $scope.data.selectedFile;
                var oldImageSrc = $scope.data.imageSrc;
                $scope.data.selectedFile = null;
                $scope.data.imageSrc = null;
                $scope.data.takingPhoto = true;
                var deferred = takePhoto.takePhoto({
                    videoElement: $scope.data.videoElement,
                    captureMode: true
                });
                deferred.then(function(result) {
                    $scope.data.takingPhoto = false;
                    $scope.data.imageSrc = result;
                }, function() {
                    $scope.data.takingPhoto = false;
                    $scope.data.selectedFile = oldSelectedFile;
                    $scope.data.imageSrc = oldImageSrc;
                });

                $scope.capturePhoto = function() {
                    deferred.capture();
                };
            };

            $scope.removeImage = function() {
                var userId = $parse($attrs.userId)($parent);
                if(!userId) { throw 'wrong user id'; }
                var image = $injector.get('image');
                confirm.show('CONFIRM_IMAGE_REMOVAL').then(function() {
                    image.remove({
                        type: $attrs.userType,
                        id: userId,
                        successTitle: 'The image was removed',
                        failedTitle: 'The image could not be removed'
                    });

                    $scope.data.selectedFile = null;
                    $scope.data.imageSrc = null;
                    $scope.data.fileInputElement.value = '';
                });
            };

            $scope.saveImage = function() {
                if($attrs.userType === 'Member:Server') {
                    var server = $injector.get('server');
                    usSpinnerService.spin('imageSpinner');
                    var s = $scope.data.imageSelection;
                    var url = '/api/memberapi/image/set?x=' + s.x1 + '&y=' + s.y1 + '&w=' + s.width + '&h=' + s.height;
                    server.postFile(url, $scope.data.selectedFile || $scope.data.imageSrc, 'The image was uploaded correctly', 'The image could not be uploaded').then(function() {
                        usSpinnerService.stop('imageSpinner');
                        $scope.data.selectedFile = null;
                        $scope.data.imageSrc = null;
                        $scope.data.fileInputElement.value = '';
                    });
                } else {
                    var userId = $parse($attrs.userId)($parent);
                    if(!userId) { throw 'wrong user id'; }
                    usSpinnerService.spin('imageSpinner');
                    var image = $injector.get('image');
                    image.set({
                        type: $attrs.userType,
                        id: userId,
                        imageSelection: $scope.data.imageSelection,
                        file: $scope.data.selectedFile || $scope.data.imageSrc,
                        successTitle: 'The image was uploaded correctly',
                        failedTitle: 'The image could not be uploaded'
                    }).then(function() {
                        usSpinnerService.stop('imageSpinner');
                        $scope.data.selectedFile = null;
                        $scope.data.imageSrc = null;
                        $scope.data.fileInputElement.value = '';
                    });
                }
            };

            $scope.useFacebookImage = function() {
                var userId = $parse($attrs.userId)($parent);
                if(!userId) { throw 'wrong user id'; }
                var server = $injector.get('server');
                server.post('/api/image/setfb', null, {id: userId}, 'Facebook image was imported', 'Failed to import Facebook image');
            };

            $scope.generateQRCode = function() {
                var rs1 = Math.random().toString(36).substr(2, 8);
                var rs2 = Math.random().toString(36).substr(2, 8);
                var rs3 = Math.random().toString(36).substr(2, 8);
                var randomString = rs1 + rs2 + rs3;
                var newQRCode;
                var modalInstance = $modal.open({
                    templateUrl: 'views/showqrcode.html',
                    controller: ['$scope', function($scope) {
                        $scope.newQRCodeStr = randomString;
                        setTimeout(function(){
                            newQRCode = angular.element(document.querySelector('qr > img')).context.getAttribute('ng-src');
                            $scope.$close();
                        }, 1000);
                    }],
                    backdrop: 'static'
                });
                modalInstance.result.then(function() {
                    var userId = $parse($attrs.userId)($parent);
                    if(!userId) { throw 'wrong user id'; }
                    usSpinnerService.spin('imageSpinner');
                    var image = $injector.get('image');
                    $scope.data.imageSrc = newQRCode;
                    $scope.data.imageSelection = {x1: 0, y1: 0, x2: 250, y2: 250, width: 250, height: 250};
                    image.set({
                        type: $attrs.userType,
                        id: userId,
                        imageSelection: $scope.data.imageSelection,
                        remove_old: true,
                        file: $scope.data.selectedFile || $scope.data.imageSrc,
                        successTitle: 'QR-code was generated successfully',
                        failedTitle: 'Failed to generate QR-code'
                    }).then(function() {
                        usSpinnerService.stop('imageSpinner');
                        $scope.data.selectedFile = null;
                        $scope.data.imageSrc = null;
                        var resource = {id: userId, qrcode_entry_id: randomString};
                        server.post('/api/resource/change', resource, null);
                    });
                });
            };

            $scope.printQRCode = function() {
                var resource = $rootScope.getMember($parse($attrs.userId)($parent));
                var source = document.querySelector('take-photo-component > div > img').src;
                var popupWin = window.open('', '_blank', '');
                popupWin.document.open();
                var printContents = '<html><head><link rel="stylesheet" type="text/css" href="styles/main.css" /></head><body style="text-align:center;" onload="window.print()"><div style="margin-top: 50px;"><img style="vertical-align:middle;" src="' + source + '"><h1>' + resource.name + '</h1></div></body></html>';
                popupWin.document.write(printContents);
                popupWin.document.close();
            };

            $scope.isExpo = $rootScope.isExpoApp;
            $scope.expoChangeImage = function() {
                takePhoto.takePhoto({ captureMode: false }).then(function(image) {
                    $scope.data.imageSrc = image;
                });
            };

        }
    };
}]);
